<div class="ReviewInfo">

  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card" style="width:100%;" id="InsuredInfo">
      <ul class="nav nav-tabs listdata" role="tablist">
        <li role="presentation" class="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Review and Confirm'|translate}}</a></li>

      </ul>
      <div class="tab-content detailsTab" style="padding: 25px;">
        <div role="tabpanel" class="tab-pane active" id="home">


          <div class="ReviewDiv">

            <div class="row">
              <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                <div class="PolicyPeriodInfo">
                  <div class="card" style="width:100%;">
                    <ul class="nav nav-tabs Sublistdata" role="tablist">
                      <li role="presentation" class="active">
                        <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Insured Info'|translate}}</a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div role="tabpanel" class="tab-pane active PolicyInfo">
                        <label> <span class="lbltext">{{'Insured Name'|translate}}:</span><span>{{proposalObj.Insured_Name}}</span>
                        </label>
                        <label> <span class="lbltext">{{'Date of Birth'|translate}}:</span><span>
                            {{proposalObj.IDOBStr}}</span>
                        </label>
                        <label> <span class="lbltext">{{'Nationality'|translate}}:</span><span>
                            {{proposalObj.NatNameEn}}
                          </span> </label>

                        <label> <span class="lbltext">{{'Building No'|translate}}:</span><span>{{proposalObj.Insured_BuildingNo}}</span>
                        </label>
                        <label> <span class="lbltext">
                            {{'Additional Code'|translate}}:</span><span>
                            {{proposalObj.Insured_AdditionalCode}}</span>
                        </label>
                        <label> <span class="lbltext">
                            {{'Street Name'|translate}}:</span><span>
                            {{proposalObj.Insured_StreetName}}</span>
                        </label>
                        <label> <span class="lbltext">
                            {{'District Name'|translate}}:</span><span>
                            {{proposalObj.Insured_DistName}}</span>
                        </label>
                        <label> <span class="lbltext">
                            {{'Postal Code'|translate}}:</span><span>
                            {{proposalObj.Insured_POPostalCode}}</span>
                        </label>
                        <label> <span class="lbltext">
                            {{'Address Type'|translate}}:</span><span>
                            {{proposalObj.AddressType}}</span></label>




                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                <div class="PolicyPeriodInfo">
                  <div class="card proposal" style="width:100%;" [hidden]="false">
                    <ul class="nav nav-tabs Sublistdata" role="tablist">
                      <li role="presentation" class="active">
                        <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Policy Info'|translate}}</a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div role="tabpanel" class="tab-pane active PolicyInfo">
                        <!-- <label> <span class="lbltext">{{'Limit of Liability'|translate}} :</span><span> {{LimitofLiabilityEn}}</span> </label>
                                                                                                      <label> <span class="lbltext"> {{'Scheme'|translate}}:</span><span> {{SchemeEn}}</span> </label>
                                                                                                      <label> <span class="lbltext">{{'Period'|translate}}:</span><span> {{proposalObj.ProposalPeriod}} {{'Year(s)'|translate}} </span> </label>
                                                                                                      <label> <span class="lbltext">{{'Name of Hospital'|translate}}:</span><span>{{NameofHospitalEn}}</span> </label>
                                                                                                      <label> <span class="lbltext">{{'Profession'|translate}}:</span><span>{{ProfessionEn}}</span> </label>
                                                                                                      <label> <span class="lbltext">{{'Premium'|translate}}:</span><span>{{proposalObj.TotalPremium}}(SAR)</span> </label> -->


                        <label> <span class="lbltext">{{'Limit of Liability'|translate}}:</span>
                          <span *ngIf="Lng=='en'">
                            {{LimitofLiabilityEn}}</span><span *ngIf="Lng=='ar'">
                            {{LimitofLiabilityAr}}</span>
                        </label>
                        <label> <span class="lbltext">
                            {{'Scheme'|translate}}:</span><span *ngIf="Lng=='en'">
                            {{SchemeEn}}</span>
                          <span *ngIf="Lng=='ar'">
                            {{SchemeAr}}</span></label>
                        <label> <span class="lbltext">{{'Period'|translate}}:</span><span>
                            {{proposalObj.ProposalPeriod}}
                            {{'Year(s)'|translate}}
                          </span> </label>
                        <label> <span class="lbltext">{{'Name of Hospital'|translate}}:</span><span *ngIf="Lng=='en'">{{NameofHospitalEn}}</span>
                          <span *ngIf="Lng=='ar'">{{NameofHospitalAr}}</span></label>
                        <label> <span class="lbltext">{{'Profession'|translate}}:</span><span *ngIf="Lng=='en'">{{ProfessionEn}}</span>
                          <span *ngIf="Lng=='ar'">{{ProfessionAr}}</span></label>
                        <label> <span class="lbltext">{{'Premium'|translate}}:</span><span>{{ proposalObj.TotalPremium | number : '1.2-2' }}(SAR)</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="row" style="padding: 5px;">
              <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" style="padding: 10px;z-index: 5;">
                    <div class="uploadImgBtn">
                      <p style="margin: 0px;">{{'Qualification/Certificates'|translate}}</p>
                      <p *ngIf="proposalObj.Attachment1" style="margin: 0px;color: green;">{{'uploaded'|translate}}</p>
                      <i style="color: green;" class="fa fa-upload"></i>
                      <input (change)="OnSelectChooseFile($event,'Qualification','Qualification','Qualification')" class="chooseFile" type="file" name="fileToUpload" id="fileToUpload">
                    </div>
                    <p *ngIf="proposalObj.Attachment1" (click)="ViewImage(proposalObj.Attachment1)" class="viewImage uploaded">{{'view attachment' | translate}}</p>

                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" style="padding: 10px;z-index: 5;">
                    <div class="uploadImgBtn">
                      <p style="margin: 0px;">{{'Medical Approved Licensed Copy'|translate}}</p>
                      <p *ngIf="proposalObj.Attachment2" style="margin: 0px;color: green;">{{'uploaded'|translate}}</p>
                      <i style="color: green;" class="fa fa-upload"></i>
                      <input (change)="OnSelectChooseFile($event,'LicensedCopy','LicensedCopy','LicensedCopy')" class="chooseFile" type="file" name="fileToUpload" id="fileToUpload">
                    </div>
                    <p *ngIf="proposalObj.Attachment2" (click)="ViewImage(proposalObj.Attachment2)" class="viewImage uploaded">{{'view attachment' | translate}}</p>
                    <p class="errorMsg" style="margin-top: 7px;" *ngIf="validateAttachment2() == 'required' && showError">{{'Please Upload Medical Approved Licensed Copy' | translate}}</p>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" style="padding: 10px;z-index: 5;">
                    <div class="uploadImgBtn">
                      <p style="margin: 0px;">{{'InsuredId Copy'|translate}}</p>
                      <p *ngIf="proposalObj.Attachment3" style="margin: 0px;color: green;">{{'uploaded'|translate}}</p>
                      <i style="color: green;" class="fa fa-upload"></i>
                      <input (change)="OnSelectChooseFile($event,'CustomerId','CustomerId','CustomerId')" class="chooseFile" type="file" name="fileToUpload" id="fileToUpload">
                    </div>
                    <p *ngIf="proposalObj.Attachment3" (click)="ViewImage(proposalObj.Attachment3)" class="viewImage uploaded">{{'view attachment' | translate}}</p>
                    <p class="errorMsg" style="margin-top: 7px;" *ngIf="validateAttachment3() == 'required' && showError">{{'Please Upload InsuredId Copy' |
                      translate}}</p>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" style="padding: 10px;z-index: 5;">
                    <div class="uploadImgBtn">
                      <p style="margin: 0px;">{{'Proposal Form Copy'|translate}}</p>
                      <p *ngIf="proposalObj.Attachment4" style="margin: 0px;color: green;">{{'uploaded'|translate}}</p>
                      <i style="color: green;" class="fa fa-upload"></i>
                      <input (change)="OnSelectChooseFile($event,'ProposalForm','ProposalForm','ProposalForm')" class="chooseFile" type="file" name="fileToUpload" id="fileToUpload">
                    </div>
                    <p *ngIf="proposalObj.Attachment4" (click)="ViewImage(proposalObj.Attachment4)" class="viewImage uploaded">{{'view attachment' | translate}}</p>

                  </div>
                </div>

              </div>
            </div>

          </div>





        </div>


        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div style="display: flex;flex-direction: row;justify-content: space-between;">
              <button class="btn btn-primary btnNext" name="btnPrev" id="btnPrev" (click)="goPrev()">{{'Prev'|translate}}</button>
              <button class="btn btn-primary btnNext" name="btnNext" id="btnNext" (click)="saveProposal()">{{'Next'|translate}}</button>
            </div>

          </div>
        </div>



      </div>
    </div>
  </div>
</div>


<div class="PayMethods">
	<img src="assets/img/payment-footer-en1.png">
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MedmalPortal/MedmalReviewConfirm/MedmalReviewConfirm.html